<template>
  <div class="shadow-box container py-4">
    <div
      :class="{ active: active }"
      class="relative m-1 flex h-full rounded-xl text-gray-700"
    >
      <div
        :class="[
          shadow ? 'shadow-' + shadow : '',
          {
            shadow: !shadow,
            'px-8 py-5': padding,
            'overflow-hidden': overflowHidden
          }
        ]"
        class="relative w-full h-full bg-white rounded-xl"
      >
        <slot />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    shadow: { type: String, default: "" },
    padding: { type: Boolean, default: true },
    overflowHidden: { type: Boolean, default: true },
    active: { type: Boolean, default: false }
  }
};
</script>
